import type { GoodsReceiptNote } from '../../../../lib/api/types/grn-types';

/**
 * An On Time delivery whose quantity received differs from the quantity
 * expected. It may be appealed, but on its quantity only — its dates passed.
 * The server applies the same rule (`purchasing/services/appeal_eligibility.py`).
 *
 * @param grn - the delivery row
 * @returns true when the row is appealable on quantity only
 */
export function isQuantityOnlyAppeal(grn: Pick<GoodsReceiptNote, 'on_time_status' | 'qty_mismatch'>): boolean {
  return grn.on_time_status === 'on_time' && grn.qty_mismatch === true;
}
